import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useFamily() {
    const navigate = useNavigate();
    const [state, setState] = useState({ checking: true, user: null, family: null });

    useEffect(() => {
        let cancelled = false;
        const check = async () => {
            let user;
            try {
                const { data } = await axios.get(`${API}/auth/me`, { withCredentials: true });
                user = data;
            } catch {
                navigate("/auth", { replace: true });
                return;
            }
            try {
                const { data: fam } = await axios.get(`${API}/families/mine`, { withCredentials: true });
                if (!cancelled) setState({ checking: false, user, family: fam });
            } catch {
                if (!cancelled) navigate("/onboarding", { replace: true });
            }
        };
        check();
        return () => {
            cancelled = true;
        };
    }, [navigate]);

    return state;
}
